// SEARCHBAR JS START

function openSearch() {
  document.getElementById("myOverlay").style.display = "block";
  document.body.classList.add("search_overlay_open");
}

function closeSearch() {
  document.getElementById("myOverlay").style.display = "none";
  document.body.classList.remove("search_overlay_open");
}

// SEARCHBAR JS END






